// Mock data for the gzt.com social media platform

// User avatars (placeholder URLs)
const AVATARS = {
  MALE_1: 'https://randomuser.me/api/portraits/men/1.jpg',
  MALE_2: 'https://randomuser.me/api/portraits/men/2.jpg',
  MALE_3: 'https://randomuser.me/api/portraits/men/3.jpg',
  FEMALE_1: 'https://randomuser.me/api/portraits/women/1.jpg',
  FEMALE_2: 'https://randomuser.me/api/portraits/women/2.jpg',
  FEMALE_3: 'https://randomuser.me/api/portraits/women/3.jpg',
};

// Post media (placeholder URLs)
const MEDIA = {
  TRAVEL_1: 'https://images.unsplash.com/photo-1527631746610-bca00a040d60',
  TRAVEL_2: 'https://images.unsplash.com/photo-1504150558240-0b4fd8946624',
  TECH_1: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f',
  TECH_2: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b',
  FOOD_1: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38',
  FOOD_2: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187',
  GAMING_1: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f',
  MUSIC_1: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4',
  PHOTOGRAPHY_1: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32',
};

// Users
export const users = [
  {
    id: 1,
    username: 'alex_johnson',
    name: 'Alex Johnson',
    avatar: AVATARS.MALE_1,
    rank: 'Captain',
    bio: 'Tech enthusiast and travel lover. Always looking for the next adventure.',
    joinedDate: '2022-01-15',
    groups: [1, 2, 3],
    friends: [2, 3, 5],
    posts: [1, 5, 9],
    activity: {
      postsCount: 42,
      commentsCount: 128,
      likesCount: 315,
    },
  },
  {
    id: 2,
    username: 'sarah_parker',
    name: 'Sarah Parker',
    avatar: AVATARS.FEMALE_1,
    rank: 'Lieutenant',
    bio: 'Photographer and foodie. Capturing moments and flavors around the world.',
    joinedDate: '2022-02-20',
    groups: [1, 4, 5],
    friends: [1, 4, 6],
    posts: [2, 6],
    activity: {
      postsCount: 37,
      commentsCount: 95,
      likesCount: 210,
    },
  },
  {
    id: 3,
    username: 'mike_wilson',
    name: 'Mike Wilson',
    avatar: AVATARS.MALE_2,
    rank: 'Sergeant',
    bio: 'Gamer and music producer. Creating beats and conquering virtual worlds.',
    joinedDate: '2022-03-10',
    groups: [3, 5],
    friends: [1, 5],
    posts: [3, 7],
    activity: {
      postsCount: 28,
      commentsCount: 64,
      likesCount: 180,
    },
  },
  {
    id: 4,
    username: 'emily_davis',
    name: 'Emily Davis',
    avatar: AVATARS.FEMALE_2,
    rank: 'Corporal',
    bio: 'Web developer and coffee addict. Coding by day, gaming by night.',
    joinedDate: '2022-04-05',
    groups: [2, 5],
    friends: [2, 6],
    posts: [4, 8],
    activity: {
      postsCount: 19,
      commentsCount: 47,
      likesCount: 135,
    },
  },
  {
    id: 5,
    username: 'david_brown',
    name: 'David Brown',
    avatar: AVATARS.MALE_3,
    rank: 'Major',
    bio: 'Travel blogger and adventure seeker. Exploring the world one country at a time.',
    joinedDate: '2022-01-05',
    groups: [1, 3, 5],
    friends: [1, 3],
    posts: [10],
    activity: {
      postsCount: 56,
      commentsCount: 142,
      likesCount: 387,
    },
  },
  {
    id: 6,
    username: 'lisa_taylor',
    name: 'Lisa Taylor',
    avatar: AVATARS.FEMALE_3,
    rank: 'Private',
    bio: 'Foodie and amateur chef. Experimenting with flavors and sharing recipes.',
    joinedDate: '2022-05-15',
    groups: [4, 5],
    friends: [2, 4],
    posts: [],
    activity: {
      postsCount: 12,
      commentsCount: 38,
      likesCount: 95,
    },
  },
];

// Groups
export const groups = [
  {
    id: 1,
    name: 'Travel Enthusiasts',
    icon: '✈️',
    description: 'A community for travel lovers to share experiences, tips, and destinations.',
    members: 12500,
    posts: [1, 5, 10],
    category: 'Travel',
    isPopular: true,
  },
  {
    id: 2,
    name: 'Web Development',
    icon: '💻',
    description: 'Discuss the latest in web development, share resources, and get help with coding challenges.',
    members: 8700,
    posts: [2, 4],
    category: 'Technology',
    isPopular: true,
  },
  {
    id: 3,
    name: 'Gaming Hub',
    icon: '🎮',
    description: 'Connect with fellow gamers, discuss the latest releases, and share gaming moments.',
    members: 15200,
    posts: [3, 7],
    category: 'Gaming',
    isPopular: true,
  },
  {
    id: 4,
    name: 'Food & Recipes',
    icon: '🍳',
    description: 'Share your favorite recipes, food photos, and culinary adventures.',
    members: 9300,
    posts: [6],
    category: 'Food',
    isPopular: false,
  },
  {
    id: 5,
    name: 'Photography',
    icon: '📷',
    description: 'A place for photographers to share their work, techniques, and gear recommendations.',
    members: 11000,
    posts: [8, 9],
    category: 'Arts',
    isPopular: true,
  },
];

// Posts
export const posts = [
  {
    id: 1,
    title: 'My Amazing Trip to Bali',
    description: 'Just returned from an incredible 2-week adventure in Bali. The beaches, temples, and food were absolutely amazing! Here are some highlights from my trip...',
    media: MEDIA.TRAVEL_1,
    mediaType: 'image',
    user: users[0],
    group: groups[0],
    likes: 245,
    comments: 42,
    timeAgo: '2 hours ago',
    showJoinButton: false,
  },
  {
    id: 2,
    title: 'Building Responsive Websites with CSS Grid',
    description: 'I\'ve been working with CSS Grid lately and it\'s revolutionized how I approach responsive design. Here\'s a quick tutorial on how to get started...',
    media: MEDIA.TECH_1,
    mediaType: 'image',
    user: users[1],
    group: groups[1],
    likes: 189,
    comments: 35,
    timeAgo: '5 hours ago',
    showJoinButton: false,
  },
  {
    id: 3,
    title: 'Review: The Latest RPG Everyone\'s Talking About',
    description: 'After 50+ hours of gameplay, I\'m ready to share my thoughts on this epic RPG. From the stunning visuals to the engaging storyline...',
    media: MEDIA.GAMING_1,
    mediaType: 'image',
    user: users[2],
    group: groups[2],
    likes: 312,
    comments: 67,
    timeAgo: '1 day ago',
    showJoinButton: true,
  },
  {
    id: 4,
    title: 'JavaScript Tips for Beginners',
    description: 'Starting your journey with JavaScript? Here are 10 essential tips that I wish someone had told me when I was learning...',
    media: MEDIA.TECH_2,
    mediaType: 'image',
    user: users[3],
    group: groups[1],
    likes: 156,
    comments: 28,
    timeAgo: '2 days ago',
    showJoinButton: false,
  },
  {
    id: 5,
    title: 'Hidden Gems in Southeast Asia',
    description: 'Beyond the popular tourist destinations, Southeast Asia has some incredible hidden gems. Here are my top 5 off-the-beaten-path locations...',
    media: MEDIA.TRAVEL_2,
    mediaType: 'image',
    user: users[0],
    group: groups[0],
    likes: 278,
    comments: 51,
    timeAgo: '3 days ago',
    showJoinButton: false,
  },
  {
    id: 6,
    title: 'Homemade Pizza Recipe That Will Impress Your Friends',
    description: 'After years of perfecting my pizza dough recipe, I\'m finally sharing it! This crispy yet chewy crust with the perfect sauce-to-cheese ratio...',
    media: MEDIA.FOOD_1,
    mediaType: 'image',
    user: users[1],
    group: groups[3],
    likes: 203,
    comments: 39,
    timeAgo: '4 days ago',
    showJoinButton: true,
  },
  {
    id: 7,
    title: 'The Evolution of Gaming Consoles',
    description: 'From the Atari 2600 to the latest next-gen systems, let\'s take a nostalgic journey through the evolution of gaming consoles...',
    media: null,
    mediaType: null,
    user: users[2],
    group: groups[2],
    likes: 187,
    comments: 45,
    timeAgo: '5 days ago',
    showJoinButton: false,
  },
  {
    id: 8,
    title: 'Capturing the Perfect Sunset: Photography Tips',
    description: 'Sunset photography can be challenging but rewarding. Here are my top techniques for capturing those magical golden hour moments...',
    media: MEDIA.PHOTOGRAPHY_1,
    mediaType: 'image',
    user: users[3],
    group: groups[4],
    likes: 231,
    comments: 37,
    timeAgo: '6 days ago',
    showJoinButton: false,
  },
  {
    id: 9,
    title: 'Street Photography: Capturing Urban Life',
    description: 'Street photography allows us to document everyday life and human behavior. Here\'s how I approach capturing authentic moments in urban environments...',
    media: null,
    mediaType: null,
    user: users[0],
    group: groups[4],
    likes: 198,
    comments: 29,
    timeAgo: '1 week ago',
    showJoinButton: false,
  },
  {
    id: 10,
    title: 'Backpacking Through Europe on a Budget',
    description: 'Just completed a 3-month backpacking trip across Europe on a tight budget. Here\'s how I visited 12 countries without breaking the bank...',
    media: null,
    mediaType: null,
    user: users[4],
    group: groups[0],
    likes: 267,
    comments: 58,
    timeAgo: '1 week ago',
    showJoinButton: false,
  },
];

// Messages
export const messages = [
  {
    id: 1,
    sender: users[0],
    receiver: users[1],
    content: 'Hey Sarah, how\'s your photography project coming along?',
    timestamp: '2023-06-10T10:30:00',
    read: true,
  },
  {
    id: 2,
    sender: users[1],
    receiver: users[0],
    content: 'Hi Alex! It\'s going great, thanks for asking. I\'m just finishing up the editing. Would love your feedback!',
    timestamp: '2023-06-10T10:35:00',
    read: true,
  },
  {
    id: 3,
    sender: users[0],
    receiver: users[1],
    content: 'Of course! I\'d be happy to take a look. When do you think you\'ll have it ready to share?',
    timestamp: '2023-06-10T10:38:00',
    read: true,
  },
  {
    id: 4,
    sender: users[1],
    receiver: users[0],
    content: 'I should have it ready by tomorrow. I\'ll send you a link when it\'s done!',
    timestamp: '2023-06-10T10:42:00',
    read: true,
  },
  {
    id: 5,
    sender: users[0],
    receiver: users[1],
    content: 'Sounds good! Looking forward to it. 👍',
    timestamp: '2023-06-10T10:45:00',
    read: true,
  },
  {
    id: 6,
    sender: users[2],
    receiver: users[0],
    content: 'Alex, are you joining the gaming session tonight?',
    timestamp: '2023-06-10T14:20:00',
    read: false,
  },
  {
    id: 7,
    sender: users[3],
    receiver: users[1],
    content: 'Sarah, I loved your recent photos from the mountain trip! Which camera did you use?',
    timestamp: '2023-06-09T09:15:00',
    read: true,
  },
  {
    id: 8,
    sender: users[1],
    receiver: users[3],
    content: 'Thanks Emily! I used my Sony Alpha a7 III with a 24-70mm lens. The lighting was perfect that day!',
    timestamp: '2023-06-09T09:30:00',
    read: true,
  },
];

// Notifications
export const notifications = [
  {
    id: 1,
    user: users[1],
    type: 'like',
    content: 'liked your post',
    post: posts[0],
    timestamp: '2023-06-10T15:30:00',
    read: false,
  },
  {
    id: 2,
    user: users[2],
    type: 'comment',
    content: 'commented on your post',
    post: posts[0],
    timestamp: '2023-06-10T14:45:00',
    read: false,
  },
  {
    id: 3,
    user: users[3],
    type: 'friend',
    content: 'sent you a friend request',
    post: null,
    timestamp: '2023-06-10T12:20:00',
    read: true,
  },
  {
    id: 4,
    group: groups[2],
    type: 'group',
    content: 'New post in',
    post: posts[3],
    timestamp: '2023-06-10T10:15:00',
    read: true,
  },
  {
    id: 5,
    user: users[4],
    type: 'mention',
    content: 'mentioned you in a comment',
    post: posts[5],
    timestamp: '2023-06-09T18:30:00',
    read: true,
  },
];

// Comments
export const comments = [
  {
    id: 1,
    post: posts[0],
    user: users[1],
    content: 'This looks amazing! Bali is definitely on my bucket list. How was the food?',
    timestamp: '2023-06-10T11:30:00',
    likes: 12,
    replies: [
      {
        id: 2,
        user: users[0],
        content: 'The food was incredible! So many fresh and flavorful dishes. You have to try the Nasi Goreng and Babi Guling when you go!',
        timestamp: '2023-06-10T11:45:00',
        likes: 5,
      },
      {
        id: 3,
        user: users[1],
        content: 'Thanks for the recommendations! I\'ll definitely check those out.',
        timestamp: '2023-06-10T12:00:00',
        likes: 2,
      },
    ],
  },
  {
    id: 4,
    post: posts[0],
    user: users[2],
    content: 'Great photos! Which part of Bali was your favorite?',
    timestamp: '2023-06-10T13:15:00',
    likes: 8,
    replies: [
      {
        id: 5,
        user: users[0],
        content: 'I loved Ubud for its cultural vibe and the rice terraces, but the beaches in Uluwatu were also stunning!',
        timestamp: '2023-06-10T13:30:00',
        likes: 4,
      },
    ],
  },
  {
    id: 6,
    post: posts[1],
    user: users[3],
    content: 'This is exactly what I needed! I\'ve been struggling with responsive layouts and this makes it so much clearer.',
    timestamp: '2023-06-10T09:45:00',
    likes: 15,
    replies: [],
  },
];

// Export all data
export default {
  users,
  groups,
  posts,
  messages,
  notifications,
  comments,
};
